// javascript to set deleted nested users in admins and teachers to nil so that they will not be created
window.deleteNestedNewUser = bin => {
  let textField = bin.closest(".admins_teachers").querySelector(".form-group__form-control")
  textField.value = '';
}
